import {createContext} from 'react';

import {SourcingCebiaReportSummary} from '@dms/api/vehicle';

export const SourcingCebiaReportContext = createContext<{
  reports: Partial<Record<string, SourcingCebiaReportSummary>>;
  isLoading: boolean;
  isError: boolean;
  canReadReport: boolean;
  refresh: () => void;
} | null>(null);
